import { Box } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { ReactNode } from "react-markdown";

import { GroundlightButton } from "new-components/buttons/GroundlightButton";

type CollapsibleTextProps = {
  children: ReactNode;
  maxHeight: number;
};

export function CollapsibleText({ children, maxHeight }: CollapsibleTextProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [expanded, setExpanded] = useState(false);

  /**
   * Whenever the children changes check the overflow to show the button.
   */
  useEffect(() => {
    const element = contentRef.current;

    if (element) {
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [children]);

  return (
    <Box>
      <Box
        ref={contentRef}
        height={expanded ? "none" : maxHeight}
        overflow="hidden"
        style={{
          transition: "all 0.3s ease",
        }}
      >
        {children}
      </Box>

      {isOverflowing && (
        <GroundlightButton sx={{ padding: 0 }} variant="plain" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Show less" : "Show more"}
        </GroundlightButton>
      )}
    </Box>
  );
}
